import React from 'react';

import CookieList from '@components/CookieBanner/V3/CookieList';
import { COOKIE_CATEGORY, getCategoriesDetails } from '@components/CookieBanner/V3/utils';
import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';

interface PanelCategoryDetailsProps {
  category: unknown[];
  // eslint-disable-next-line react/forbid-prop-types
  rawCookieBanner: object;
}

const PanelCategoryDetails = ({
  category,
  rawCookieBanner
}: PanelCategoryDetailsProps) => {
  const { cookieInfoLabels } = rawCookieBanner;
  const { title, description, cookies } = getCategoriesDetails(
    rawCookieBanner,
    category,
    cookieInfoLabels
  );

  return (
    <CookieBannerPanel.Root>
      <CookieBannerPanel.Title>{title}</CookieBannerPanel.Title>
      <CookieBannerPanel.Description isMessage parseHTML>
        {description}
      </CookieBannerPanel.Description>
      <CookieList items={cookies} />
    </CookieBannerPanel.Root>
  );
};

export default PanelCategoryDetails;
